/* eslint-disable react-hooks/exhaustive-deps */
// wijmo
import { faPlusSquare } from "@fortawesome/free-regular-svg-icons"
import {
  faChevronDown,
  faChevronUp,
  faSearch,
} from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import * as wjCore from "@grapecity/wijmo"
import * as wjGrid from "@grapecity/wijmo.grid"
import * as wjrGrid from "@grapecity/wijmo.react.grid"
import dayjs from "dayjs"

// other
import queryString from "query-string"
import { useEffect, useState } from "react"
import {
  Button,
  Card,
  Col,
  Collapse,
  Container,
  Form,
  Row,
} from "react-bootstrap"
import { useDispatch, useSelector } from "react-redux"
import { Link, useHistory, useLocation } from "react-router-dom"
import { AppDispatch } from "../../.."
import AlertComponent from "../../../components/AlertComponent"
import DisplaySearchConditionLabel from "../../../components/DisplaySearchConditionLabel"
import FlexGridOuter from "../../../components/FlexGridWrapper/FlexGridOuter"
import DateInput from "../../../components/InputWrapper/DateInput"
import TextInput from "../../../components/InputWrapper/TextInput"
import Spinner from "../../../components/Spinner"
import CONST from "../../../constant"
import { メニューコード } from "../../../constant/menuCode"
import VALIDATE_CONSTANT from "../../../constant/validateConstant"
import { clearAlert, setAlerts } from "../../../globalStore/alertStore"
import {
  画面ロック解除,
  画面ロック開始,
} from "../../../globalStore/progressStore"
import { RootState } from "../../../globalStore/rootreducer"
import OsiraseService from "../../../service/master/osirase/osiraseService"
import {
  TOsiraseListGetReq,
  TOsiraseGetListRes,
} from "../../../service/master/osirase/TOsirase"
import gridPageHelper from "../../../ts/helpers/gridPageHelper"
import pageHelper from "../../../ts/helpers/pageHelper"
import util from "../../../ts/util"
import {
  osiraseExcelFormat,
  osirasePdfFormat,
} from "../../../ts/util/exportUtil"
import { TWijmoCellTemplateContext } from "../../../type/wijmoComponents"

/**
 * お知らせ一覧
 * @returns
 */
const OsiraseList = () => {
  const history = useHistory()
  const location = useLocation()

  // ページエンター時のクエリを保持。AsyncAutoCompleteのdefaultValue用
  //   const firstQuery = queryString.parse(location.search)

  const 読取専用フラグ = useSelector(
    (rootState: RootState) =>
      rootState.menu.menuPage.find(
        (m) => m.メニューコード === メニューコード.マスタ管理.お知らせ一覧
      )?.読み取り専用フラグ
  )

  //TODO:ページ名称確定必須
  let gridId = "OsiraseList_GridId"

  //#region [method]

  /**
   * collectionView作成用
   * @param data gridに入れるデータ
   * @param pageSize ページ当たりの行数
   * @returns CollectionView
   */
  const createCollectionView = (data: Array<any>, pageSize: number) =>
    new wjCore.CollectionView(data, {
      pageSize,
      // GridFooterからのイベント伝達用
      onPageChanged() {
        if (flexGrid && flexGrid.itemsSource) {
          const pageIndex = flexGrid!.itemsSource!.pageIndex
          setPageNumber(pageIndex)
        }
      },
    })

  /**
   * 検索処理
   * @param searchCondition 検索条件
   */
  const search = async (searchCondition?: TOsiraseListGetReq) => {
    setIsSearching(true) // 検索中状態に遷移
    dispatch(clearAlert()) // アラートを非表示に

    let currentSearchCondition: TOsiraseListGetReq
    // 検索条件生成
    if (searchCondition) {
      // 引数の検索条件を使用
      currentSearchCondition = searchCondition
    } else {
      // stateから検索条件を生成
      currentSearchCondition = createSearchCondition()
    }
    // QueryStringに検索条件を反映
    pageHelper.pushQuery(history, location, currentSearchCondition)

    //表示用の検索条件を作成
    setDisplaySearchCondition(
      createDisplaySearchCondition(currentSearchCondition)
    )

    try {
      const res = await new OsiraseService().getList(currentSearchCondition)

      // 検索結果をstateにセット
      setGridData({ data: createCollectionView(res.data, pageSize) })
    } catch (error) {
      dispatch(setAlerts(error))
    } finally {
      setIsSearching(false) // 検索中状態に遷移
    }
  }

  /**
   * URL Queryを解析
   */
  const queryParse = () => {
    const query: TOsiraseListGetReq = queryString.parse(location.search)
    set掲載日(query.掲載日)
    setタイトル(query.タイトル ?? "")
    set社員コード(query.社員コード ?? "")
    set社員氏名(query.社員氏名 ?? "")

    return query
  }

  /**
   * 検索条件オブジェクトを生成
   */
  const createSearchCondition = (): TOsiraseListGetReq => {
    return {
      掲載日: 掲載日 ?? undefined,
      タイトル,
      社員コード,
      社員氏名,
    }
  }

  /**
   * 表示用検索条件オブジェクトを生成
   */
  const createDisplaySearchCondition = (
    searchCondition: TOsiraseListGetReq
  ) => {
    const disp掲載日 = searchCondition.掲載日
      ? dayjs(searchCondition.掲載日).format("YYYY/MM/DD")
      : ""
    return {
      掲載日: wjCore.isNullOrWhiteSpace(掲載日 ?? "") ? "" : disp掲載日,
      タイトル: wjCore.isNullOrWhiteSpace(searchCondition.タイトル ?? "")
        ? ""
        : searchCondition.タイトル,
      社員コード: wjCore.isNullOrWhiteSpace(searchCondition.社員コード ?? "")
        ? ""
        : searchCondition.社員コード,
      社員氏名: wjCore.isNullOrWhiteSpace(searchCondition.社員氏名 ?? "")
        ? ""
        : searchCondition.社員氏名,
    }
  }

  /**
   * 検索条件クリア処理
   */
  const searchConditionClear = () => {
    // フィルターのクリア
    if (!isSearching) {
      flexGrid!.collectionView.filter = null
      flexGrid!.collectionView.sortDescriptions.clear()
    }
    // データをすべて削除する
    const emptyCollectionView = createCollectionView([], pageSize)
    flexGrid!.itemsSource = emptyCollectionView
    setGridData({ data: emptyCollectionView })
    // 検索条件文字列をクリア
    setDisplaySearchCondition(undefined)

    clearSearchState()
    // querystringをクリア
    pageHelper.clearQuery(history, location)
  }

  const clearSearchState = () => {
    // set掲載日(当日)
    set掲載日("")
    setタイトル("")
    set社員コード("")
    set社員氏名("")
  }

  // グリッド初期化時イベントハンドラ
  const gridInitializedHandler = async (grid: wjGrid.FlexGrid) => {
    grid.formatItem.addHandler(formatItem)

    grid.refresh()
  }

  /**
   * グリッドのフォーマット
   */
  const formatItem = (f: wjGrid.FlexGrid, e: wjGrid.FormatItemEventArgs) => {
    if (e.panel === f.cells) {
      const cellBinding = e.getColumn().binding
      if (cellBinding !== null && e.getRow().dataIndex !== -1) {
        //削除済フラグの行はreadonly
        if (e.getRow().dataItem.削除フラグ) {
          wjCore.toggleClass(e.cell, "read-only-cell", true)
          return
        }
      }
    }
  }

  //#endregion

  //#region [baseState]

  // リストア制御用フラグ
  const [isRestoreSearching, setIsRestoreSearching] = useState<boolean>(false)

  const [flexGrid, setFlexGrid] = useState<wjGrid.FlexGrid>()
  const [pageSize, setPageSize] = useState<number>(10)
  const [gridData, setGridData] = useState<{ data: wjCore.CollectionView }>({
    data: createCollectionView([], pageSize),
  })
  const [pageNumber, setPageNumber] = useState<number>(0)

  // 検索制御用
  const [isSearching, setIsSearching] = useState(false) // 検索中

  // 検索条件表示用
  const [displaySearchCondition, setDisplaySearchCondition] = useState<{
    [propertyName: string]: any
  }>()

  //アラート制御
  const dispatch: AppDispatch = useDispatch()

  // Accordion制御
  const [accordionController, setAccordionController] = useState<boolean>(true)

  //grid初期化フラグ
  const [gridInitialized, setGridInitialized] = useState<boolean>(false)

  //#endregion

  //#region [state]
  // const [掲載日, set掲載日] = useState<string | null | undefined>()
  const [掲載日, set掲載日] = useState<string | null>()
  const [タイトル, setタイトル] = useState<string>()
  const [社員コード, set社員コード] = useState<string>()
  const [社員氏名, set社員氏名] = useState<string>()

  //#endregion

  //#region [effect]

  // wijmoコンポーネントの初期化 および ComboBoxなどのロード完了後、前回状態の復元処理を行う
  useEffect(() => {
    //gridやcomboBoxの生成完了を確認
    if (gridInitialized) {
      //初回filter作成時にqueryがいた場合、検索を行う
      if (location.search !== "") {
        // 遷移してきた際のクエリパラメータで検索条件を生成
        const querySearchCondition = queryParse()

        // リストア中フラグON
        setIsRestoreSearching(true)

        // 再検索
        search(querySearchCondition).finally(() => {
          dispatch(画面ロック解除())
        })
      } else {
        // 単純遷移の場合はフィルタ条件を削除する
        gridPageHelper.removePageConditionData()
        gridPageHelper.removeAllGridFilterAndSortStates()
        dispatch(画面ロック解除())
      }
    }
  }, [gridInitialized])

  useEffect(() => {
    document.title = `お知らせ一覧`
    // 初期表示生成のため画面ロック
    dispatch(画面ロック開始())
  }, [])
  //#endregion

  return (
    <Container fluid>
      {/* 画面タイトル */}
      <Row className="page-title-row">
        <Col className="page-title-col">
          <span className="page-title">お知らせ一覧</span>
        </Col>
      </Row>
      {/* アラート表示 */}
      <Row>
        <Col>
          <AlertComponent />
        </Col>
      </Row>
      <Row>
        <Col>
          {/* 検索条件カード */}
          <Card className="w-90rem">
            {/* CardHeaderをアコーディオン化 */}
            <Card.Header
              onClick={() => setAccordionController(!accordionController)}
              aria-controls="collapse-search-card-body"
              aria-expanded={accordionController}>
              <FontAwesomeIcon
                icon={accordionController ? faChevronDown : faChevronUp}
                size={"1x"}
              />
              検索条件
            </Card.Header>
            <Collapse in={accordionController}>
              <Card.Body>
                <Form>
                  <Container fluid className="contents-search-main">
                    <Row>
                      <Col>
                        <div className="search-condition-table">
                          <div className="search-condition-row">
                            <div className="w-13rem">
                              <DateInput
                                id="掲載日"
                                placeholder="掲載日"
                                has1DayButton={true}
                                showHoliday={true}
                                value={掲載日}
                                setValue={set掲載日}
                              />
                            </div>
                            <div className="input-group">
                              <TextInput
                                style={{ width: "25rem" }}
                                id="タイトル"
                                name="タイトル"
                                value={タイトル}
                                setValue={setタイトル}
                                maxLength={VALIDATE_CONSTANT.LENGTH.一般名称}
                                placeholder="タイトル"
                              />
                            </div>
                            <div className="input-group">
                              <TextInput
                                style={{ width: "6rem" }}
                                id="社員番号"
                                name="社員番号"
                                value={社員コード}
                                setValue={set社員コード}
                                maxLength={VALIDATE_CONSTANT.LENGTH.社員コード}
                                placeholder="社員CD"
                              />
                              <TextInput
                                id="氏名"
                                name="氏名"
                                value={社員氏名}
                                setValue={set社員氏名}
                                maxLength={VALIDATE_CONSTANT.LENGTH.一般名称}
                                placeholder="更新者氏名"
                              />
                            </div>
                          </div>
                          <div className="search-condition-row">
                            <Button
                              type="submit"
                              disabled={isSearching}
                              onClick={(e) => {
                                e.stopPropagation()
                                e.preventDefault()
                                search()
                              }}>
                              <FontAwesomeIcon icon={faSearch} />
                              検索
                            </Button>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </Container>
                </Form>
              </Card.Body>
            </Collapse>
          </Card>
        </Col>
      </Row>
      <Row>
        <Col>
          {/* 検索結果カード */}
          <Card>
            <Spinner searching={isSearching}></Spinner>
            <Card.Body>
              <Row>
                <Col>
                  {/* 検索条件表示コンポーネント */}
                  <DisplaySearchConditionLabel
                    displaySearchCondition={displaySearchCondition}
                  />
                </Col>
              </Row>
              <FlexGridOuter
                flexGrid={flexGrid}
                setFlexGrid={setFlexGrid}
                gridConstantProperties={CONST.GRID.PROPERTY_SET.FLEX_GRID_PROPS}
                gridData={gridData}
                setGridData={setGridData}
                pageNumber={pageNumber}
                searchConditionClear={searchConditionClear}
                gridId={gridId}
                isRestoreSearching={isRestoreSearching}
                setIsRestoreSearching={setIsRestoreSearching}
                gridInitialized={gridInitialized}
                setGridInitialized={setGridInitialized}
                pageSize={pageSize}
                setPageSize={setPageSize}
                gridInitializedHandler={gridInitializedHandler}
                excelFormatItem={osiraseExcelFormat}
                pdfFormatItem={osirasePdfFormat}
                headerComponent={
                  <>
                    {!読取専用フラグ && (
                      <Link
                        to={
                          util.getMenuPath(
                            メニューコード.マスタ管理.お知らせ登録
                          )[0]
                        }
                        onClick={() =>
                          gridPageHelper.savePageConditionData(
                            location.pathname
                          )
                        }>
                        <Button disabled={isSearching}>
                          <FontAwesomeIcon icon={faPlusSquare} />
                          新規追加
                        </Button>
                      </Link>
                    )}
                  </>
                }>
                <wjrGrid.FlexGridColumn
                  header=" "
                  allowMerging="true"
                  align="center"
                  width={80}
                  selectable={false}
                  isReadOnly>
                  <wjrGrid.FlexGridCellTemplate
                    cellType="Cell"
                    template={(
                      context: TWijmoCellTemplateContext<TOsiraseGetListRes>
                    ) => {
                      // お知らせ登録
                      const url = util.getMenuPath(
                        メニューコード.マスタ管理.お知らせ登録
                      )[1]

                      return (
                        <Button
                          className="btn btn-small btn-primary move-edit-page"
                          onClick={() => {
                            // 画面全体のスクロール位置の保存
                            gridPageHelper.savePageConditionData(
                              location.pathname
                            )

                            history.push(
                              url.replaceAll(
                                ":id",
                                `${context.item.お知らせID}`
                              )
                            )
                          }}>
                          {!読取専用フラグ ? "編集" : "参照"}
                        </Button>
                      )
                    }}
                  />
                </wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="掲載開始日"
                  width={120}
                  header="掲載開始日">
                  <wjrGrid.FlexGridCellTemplate
                    cellType="Cell"
                    template={(
                      context: TWijmoCellTemplateContext<TOsiraseGetListRes>
                    ) => {
                      let dDate = ""
                      if (context.item.掲載開始日)
                        dDate = dayjs(context.item.掲載開始日).format(
                          "YYYY/MM/DD"
                        )

                      return (
                        <>
                          <span>{dDate}</span>
                        </>
                      )
                    }}></wjrGrid.FlexGridCellTemplate>
                </wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="掲載終了日"
                  width={120}
                  header="掲載終了日">
                  <wjrGrid.FlexGridCellTemplate
                    cellType="Cell"
                    template={(
                      context: TWijmoCellTemplateContext<TOsiraseGetListRes>
                    ) => {
                      let dDate = ""
                      if (context.item.掲載終了日)
                        dDate = dayjs(context.item.掲載終了日).format(
                          "YYYY/MM/DD"
                        )

                      return (
                        <>
                          <span>{dDate}</span>
                        </>
                      )
                    }}></wjrGrid.FlexGridCellTemplate>
                </wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  width={100}
                  binding={"お知らせ分類区分名称1"}
                  header="カテゴリ"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  width={100}
                  binding={"部所略称"}
                  header="部所"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="タイトル"
                  width={500}
                  header="タイトル"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="更新日時"
                  format={"d"}
                  width={160}
                  header="更新日時">
                  <wjrGrid.FlexGridCellTemplate
                    cellType="Cell"
                    template={(
                      context: TWijmoCellTemplateContext<TOsiraseGetListRes>
                    ) => {
                      let dDate = ""
                      if (context.item.更新日時)
                        dDate = dayjs(context.item.更新日時).format(
                          "YYYY/MM/DD HH:mm:ss"
                        )

                      return (
                        <>
                          <span>{dDate}</span>
                        </>
                      )
                    }}></wjrGrid.FlexGridCellTemplate>
                </wjrGrid.FlexGridColumn>
              </FlexGridOuter>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  )
}

export default OsiraseList
